export var RestrictedFeatureEnum = {
  socialAuth:'social_auth',
  languages:'languages',
  currencies:'currencies',
  attributes:'attributes',
  email:'email_white_labelling',
  bulkEditCategories :"bulk_edit_categories",
  bulkEditListings :"bulk_edit_listings",
}
